import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Type, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { ErrorHandlingService } from '../../../services/error-handling.service';

@Component({
  selector: 'app-eca-image-viewer',
  templateUrl: './eca-image-viewer.component.html',
  styleUrls: ['./eca-image-viewer.component.scss']
})

export class EcaImageViewerComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() imageSrc: string;
  @Input() imageAlt: string;
  @Input() enablePreview: boolean = true;
  @Input() enableEdit: boolean = false;
  @Input() maxFileSize: number = 2097152;
  @Input() acceptedFileTypes: string = '.png, .jpg, .jpeg,';

  @Input() isSrcEncoded: boolean = true;
  @Output() imageOutput: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('imageUpload') imageUpload: FileUpload;
  //@ViewChild('imageUpload', { static: false }) imageUpload: FileUpload;

  defaultSrc: string = "assets/eCOMS_No_Image_Available.jpg";
  defaultAlt: string = "No Image Available";
  encodedImageStr: string;
  decodedImageStr: string = "assets/eCOMS_No_Image_Available.jpg";
  viewerAlt: string;
  chooseIcon: string;
  cancelEnabled: boolean = false;
  cancelIcon: string = "fa fa-trash";
  dummyFiles: File;
  errorMessage: string = '';


  constructor(private errorHandlingService: ErrorHandlingService) { }

  ngOnInit(): void {
    if (!this.imageSrc) {
      this.decodedImageStr = this.defaultSrc;
    }
    if (!this.imageAlt) {
      this.viewerAlt = this.defaultAlt;
    }

    //Dirty fix - need to create a dummy File for the uploader
    let blob = null;
    blob = new Blob();
    blob.lastModifiedDate = new Date();
    blob.name = this.defaultSrc;
    this.dummyFiles = blob;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isSrcEncoded) {
      this.isSrcEncoded = changes.isSrcEncoded.currentValue;
    }

    if (changes.imageSrc?.currentValue) {
      var newImageSrc = changes.imageSrc.currentValue;
      if (this.isSrcEncoded) {
        this.encodedImageStr = newImageSrc
        this.decodedImageStr = atob(this.encodedImageStr);//Decode imageSrc if it is encoded        
      }
      else {
        this.encodedImageStr = btoa(newImageSrc);
        this.decodedImageStr = newImageSrc;//No decode required
      }
    }

    if (changes.imageAlt?.currentValue) {
      this.viewerAlt = changes.imageAlt.currentValue;
    }

    //button labels, icon and visibility manipulation
    this.chooseIcon = this.encodedImageStr ? "fa fa-rotate" : "fa fa-plus";
    this.cancelEnabled = this.encodedImageStr ? true : false;
    if (this.cancelEnabled && !this.imageUpload.hasFiles()) {
      this.imageUpload.files.push(this.dummyFiles);//Dirty fix - pushing a dummy file enables the cancel button
    }
  }

  onFileRemove() {
    this.decodedImageStr = this.defaultSrc;
    this.encodedImageStr = "";
    this.cancelEnabled = false;
    this.chooseIcon = "fa fa-plus";
    this.imageOutput.emit(""); //output the new encoded imageSrc
  }

  onFileAdd(event) {
    for (let file of event.files) {
      var fileCheckPassed = true;

      //file size check (only check if it has passed all previous checks)
      if (file.size > this.maxFileSize && fileCheckPassed) {
        fileCheckPassed = false;
        this.errorMessage = `<strong>${file.name}</strong> exceeds the maximum upload size permitted (2MB)`;
        this.errorHandlingService.showErrorWarning(this.errorMessage).subscribe(userResponse => {
        });
      }

      //file type check (only check if it has passed all previous checks)
      if (!file.type.match('image/') && fileCheckPassed) {
        fileCheckPassed = false;
        this.errorMessage = `<strong>${file.name}</strong> is not a permitted image file`;
        this.errorHandlingService.showErrorWarning(this.errorMessage).subscribe(userResponse => {
        });
      }

      //file checks passed so read image
      if (fileCheckPassed)
      {
        this.readImageFile(file);
      }
    }
  }

  readImageFile(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {
      this.decodedImageStr = reader.result.toString();
      this.encodedImageStr = btoa(this.decodedImageStr);
      if (this.isSrcEncoded) {
        this.imageOutput.emit(this.encodedImageStr); //output encoded imageString
      }
      else {
        this.imageOutput.emit(this.decodedImageStr); //output decoded imageString
      }
    }
  }
}
